import { useTranslation } from "react-i18next";
import {
  LANGUAGE_ENDONYMS,
  supportedLngs,
  type SupportedLng,
} from "@heraion/i18n";

import type { UiTheme } from "../theme";
import { SettingsPillChoice } from "./SettingsPillChoice";

// #179: THE language-pill block: the sign-in door (web SignInForm, mobile
// LoginScreen) and the web Preferences screen use it, `onPick` being the only
// difference. Born as the language choice on the sign-in door, before any profile exists to
// deduce it from. One component for both hosts (web SignInForm, mobile
// LoginScreen); each host owns HOW the choice is applied and persisted
// (web: i18n.changeLanguage + the detector's localStorage cache; mobile:
// setLanguage). The default is the system language, which both hosts'
// initialisation already resolves; `value` is whatever is active now.
export function PreauthLanguagePicker({
  theme,
  value,
  onPick,
}: {
  theme: UiTheme;
  value: SupportedLng;
  onPick: (lng: SupportedLng) => void;
}) {
  const { t } = useTranslation();
  return (
    <SettingsPillChoice<SupportedLng>
      theme={theme}
      labelIcon="globe"
      label={t("mobile.profile.labelLanguage", { defaultValue: "Language" })}
      options={supportedLngs.map((lng) => ({
        value: lng,
        label: LANGUAGE_ENDONYMS[lng],
      }))}
      value={value}
      onPick={onPick}
    />
  );
}
